export const DEFAULT_PUBLIC_CARTE_ID = "default";

export interface PublicCarteQueryParams {
  customerHash: string;
  userId: string;
  carteId?: string;
}

export interface PublicCarteAccessParams {
  customerHash: string;
  userId?: string;
  carteId?: string;
}

function createPublicCarteSearch(params: PublicCarteQueryParams): string {
  const search = new URLSearchParams({
    customerHash: params.customerHash,
    carteId: params.carteId || DEFAULT_PUBLIC_CARTE_ID,
  });

  if (params.userId) {
    search.set("userId", params.userId);
  }

  return `?${search.toString()}`;
}

export function buildPublicCartePath(params: PublicCarteQueryParams): string {
  return `/${createPublicCarteSearch(params)}`;
}

export function buildPublicCarteUrl(params: PublicCarteQueryParams, origin = window.location.origin): string {
  return `${origin}${buildPublicCartePath(params)}`;
}

export function buildPublicCarteApiUrl(apiBase: string, params: PublicCarteQueryParams): string {
  return `${apiBase}/api/public/carte${createPublicCarteSearch(params)}`;
}

export function buildPublicOrderApiUrl(apiBase: string, params: PublicCarteAccessParams): string {
  const search = new URLSearchParams({
    customerHash: params.customerHash,
  });

  if (params.userId) {
    search.set("userId", params.userId);
  }

  search.set("carteId", params.carteId || DEFAULT_PUBLIC_CARTE_ID);

  return `${apiBase}/api/public/orders?${search.toString()}`;
}